import LookerEmbedTab from 'components/LookerEmbedTab'
import React from 'react'

const DASHBOARD_PATH = 'dashboards/276'

const ActivationByLocationTab: React.FC = () => (
  <LookerEmbedTab
    path={DASHBOARD_PATH}
    translationKey="activation_rate.tabs.activation_by_location"
  />
)

export default ActivationByLocationTab
